module.exports = __webpack_public_path__ + "static/media/ic_wechat.affcd94d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_wechat.svg
// module id = 121
// module chunks = 0